import React, { useState } from 'react';

export type BindInput = {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
};

export const useInput = (
  initialValue: string,
  field: string,
  onChangeHook?: (field: string, value: string) => void,
  onBlurHook?: (field: string, value: string) => void,
) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setValue(value);
        if (onChangeHook) {
          onChangeHook(field, value);
        }
      },
      ...(onBlurHook ? { onBlur: () => onBlurHook(field, value) } : {}),
    },
  };
};
